export default __webpack_public_path__ + "static/media/bg2.f4a8a375.png";